import "./ActionButton.scss";

const ActionButtonStandard = ({ label, iconImg, handleClick, disabled, onClick, className, useSvgIcon }) => {
   return (
      <button
         className={"action-btn " + (disabled ? "disabled" : "") + (className && className)}
         onClick={handleClick || onClick}
      >
         {iconImg && (
            useSvgIcon ? (
               <span className="action-btn__icon">{iconImg}</span>
            ) : (
               <img src={iconImg} alt="icon" aria-hidden="true" className="action-btn__icon" />
            )
         )}
         {label && <p className="action-btn__label">{label}</p>}
      </button>
   );
};

export default ActionButtonStandard;
